/* Čapkov redesign: kontaktní formulář (capkov-rd-kontakt), kolo 2. Multipart POST do Gatherina (formulář capkov-kontakt; endpoint v nastavení sekce, data-api).
   Téma + číslo objednávky + telefon odcházejí jako samostatná, pojmenovaná pole (tema, objednavka, telefon). */
(function () {
  'use strict';
  var root = document.querySelector('[data-rd-kt]'); if (!root || root.__ktInit) return; root.__ktInit = true;
  /* texty: česká záloha, překlady vkládá sekce (JSON v [data-kt-dict], texty z locale klíčů) */
  var DEF = {"v_name": "Napiš nám prosím své jméno.", "v_email0": "Zadej prosím svůj e-mail.", "v_email": "Zkontroluj prosím e-mail, vypadá neúplně.", "v_tel": "Telefon může obsahovat jen číslice, mezery, + a pomlčky.", "v_order": "Číslo objednávky zadej třeba jako #8571.", "v_msg": "Napiš nám prosím zprávu (aspoň pár slov).", "f_type": "Tenhle formát nejde nahrát (jen PNG, JPG, WebP).", "f_max": "Nejvýše {0} soubory.", "f_total": "Soubory jsou dohromady větší než 5 MB.", "f_bad": "Odeber prosím soubory, které nejdou nahrát.", "remove": "Odebrat", "sending": "Odesílám…", "uploading": "Nahrávám", "e_net": "Spojení se nepodařilo. Zkus to prosím znovu, nebo nám napiš na {0}.", "e_429": "Příliš mnoho zpráv v krátké době. Zkus to prosím za chvíli.", "e_status": "Odeslání se nepodařilo. Zkus to prosím znovu, nebo nám napiš na {0}."};
  var LANG = root.getAttribute('data-lang') === 'cs' ? 'cs' : 'en', D = {};
  try { D = JSON.parse(($('[data-kt-dict]') || {}).textContent || '{}') || {}; } catch (e) { D = {}; }
  var api = root.getAttribute('data-api'), mail = root.getAttribute('data-mail') || '';
  var MAX_FILES = 3, MAX_TOTAL = 5 * 1024 * 1024, EXT = ['png', 'jpg', 'jpeg', 'webp'], MIN_MS = 3300;
  var TEMA_CS = { order: 'Objednávka a doručení', returns: 'Vrácení a reklamace', design: 'Vlastní design', b2b: 'Pro firmy', other: 'Jiné' };
  function T(k) { var s = D[k] != null ? D[k] : (DEF[k] != null ? DEF[k] : k); for (var i = 1; i < arguments.length; i++) s = s.replace('{' + (i - 1) + '}', arguments[i]); return s; }
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || root).querySelectorAll(s)); }
  var form = $('[data-kt-form]'), card = $('[data-kt-card]'), done = $('[data-kt-done]'), sendBtn = $('[data-kt-send]'), sendLab = $('[data-kt-send-l]'), idle = sendLab.textContent;
  var fail = $('[data-kt-fail]'), failMsg = $('[data-kt-fail-m]'), list = $('[data-kt-files]'), drop = $('[data-kt-drop]'), pick = $('[data-kt-pick]');
  var openedAt = Date.now(), sending = false, files = [];

  function val(n) { return (form.elements[n] && form.elements[n].value || '').trim(); }
  function topic() { var c = $('input[name=tema]:checked', form); return c ? c.value : 'other'; }
  function setErr(n, m) {
    var el = $('[data-err="' + n + '"]'), inp = form.elements[n];
    if (el) el.textContent = m || '';
    if (inp && inp.setAttribute) { if (m) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid'); }
  }
  var rules = {
    jmeno: function () { return val('jmeno').length < 2 ? T('v_name') : ''; },
    email: function () { var v = val('email'); if (!v) return T('v_email0'); return /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v) ? '' : T('v_email'); },
    telefon: function () { var v = val('telefon'); return !v || (/^[+\d][\d\s().\-\/]{5,}$/.test(v) && v.replace(/\D/g, '').length >= 6) ? '' : T('v_tel'); },
    objednavka: function () { var v = val('objednavka'); if (!v || topic() === 'design' || topic() === 'b2b') return ''; return /^[#\w\- ]{2,24}$/.test(v) && /\d/.test(v) ? '' : T('v_order'); },
    zprava: function () { return val('zprava').length < 5 ? T('v_msg') : ''; }
  };
  Object.keys(rules).forEach(function (n) {
    var el = form.elements[n]; if (!el) return;
    el.addEventListener('blur', function () { if (el.value || el.hasAttribute('aria-invalid')) setErr(n, rules[n]()); });
    el.addEventListener('input', function () { if (el.hasAttribute('aria-invalid')) setErr(n, rules[n]()); });
  });

  /* téma -> panely */
  function applyTopic() {
    var t = topic();
    $$('[data-for]').forEach(function (p) { p.hidden = p.getAttribute('data-for').split(' ').indexOf(t) < 0; });
    var ob = form.elements.objednavka; if (ob.hasAttribute('aria-invalid')) setErr('objednavka', rules.objednavka());
  }
  $$('input[name=tema]', form).forEach(function (r) { r.addEventListener('change', applyTopic); });
  try { var q = new URLSearchParams(location.search).get('tema'); if (q && TEMA_CS[q]) { var rr = $('input[name=tema][value=' + q + ']', form); if (rr) rr.checked = true; } } catch (e) { }
  applyTopic();

  /* přílohy */
  function total() { return files.filter(function (f) { return f.ok; }).reduce(function (s, f) { return s + f.file.size; }, 0); }
  function fmt(b) { return b > 1048576 ? (b / 1048576).toFixed(1).replace('.', LANG === 'cs' ? ',' : '.') + ' MB' : Math.max(1, Math.round(b / 1024)) + ' kB'; }
  function draw() {
    list.innerHTML = '';
    if (!files.some(function (f) { return !f.ok; })) setErr('foto', '');
    files.forEach(function (f, i) {
      var li = document.createElement('li'); if (!f.ok) li.className = 'is-bad';
      var th = document.createElement('span'); th.className = 'rd-kt__th';
      if (f.ok) { var im = document.createElement('img'); im.alt = ''; try { im.src = f.url || (f.url = URL.createObjectURL(f.file)); } catch (e) { } th.appendChild(im); }
      var fi = document.createElement('span'); fi.className = 'rd-kt__fi';
      var b = document.createElement('b'); b.textContent = f.file.name; var s = document.createElement('small'); s.textContent = f.ok ? fmt(f.file.size) : f.msg;
      fi.appendChild(b); fi.appendChild(s);
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'rd-kt__rm'; rm.setAttribute('aria-label', T('remove') + ' ' + f.file.name); rm.textContent = '×';
      rm.addEventListener('click', function () { if (f.url) try { URL.revokeObjectURL(f.url); } catch (e) { } files.splice(i, 1); draw(); });
      li.appendChild(th); li.appendChild(fi); li.appendChild(rm); list.appendChild(li);
    });
  }
  function addFiles(fl) {
    setErr('foto', '');
    [].slice.call(fl).forEach(function (file) {
      var e = (file.name.split('.').pop() || '').toLowerCase(), f = { file: file, ok: true, msg: '' };
      if (EXT.indexOf(e) < 0) { f.ok = false; f.msg = T('f_type'); }
      else if (files.filter(function (x) { return x.ok; }).length >= MAX_FILES) { f.ok = false; f.msg = T('f_max', MAX_FILES); }
      else if (total() + file.size > MAX_TOTAL) { f.ok = false; f.msg = T('f_total'); }
      files.push(f);
    });
    draw();
  }
  pick.addEventListener('change', function () { addFiles(pick.files); pick.value = ''; });
  ['dragover', 'dragenter'].forEach(function (n) { drop.addEventListener(n, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (n) { drop.addEventListener(n, function (e) { e.preventDefault(); drop.classList.remove('is-over'); if (n === 'drop' && e.dataTransfer) addFiles(e.dataTransfer.files); }); });

  function validate() {
    var ok = true, first = null;
    ['jmeno', 'email', 'telefon', 'objednavka', 'zprava'].forEach(function (n) {
      var el = form.elements[n]; if (!el || (el.closest('[hidden]') && n === 'objednavka')) { setErr(n, ''); return; }
      var m = rules[n](); setErr(n, m); if (m) { ok = false; if (!first) first = el; }
    });
    if (files.some(function (f) { return !f.ok; })) { setErr('foto', T('f_bad')); ok = false; if (!first) first = pick; }
    if (first && first.focus) { first.focus({ preventScroll: true }); try { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { } }
    return ok;
  }
  function busy(b, pct) {
    sending = b; sendBtn.disabled = b; sendBtn.classList.toggle('is-busy', b);
    if (b) sendBtn.setAttribute('aria-busy', 'true'); else sendBtn.removeAttribute('aria-busy');
    sendLab.textContent = b ? (pct != null ? T('uploading') + ' ' + pct + ' %' : T('sending')) : idle;
  }
  function showFail(m) { busy(false); failMsg.innerHTML = m; fail.hidden = false; try { fail.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { } }
  function submit() {
    if (sending || !validate()) return;
    fail.hidden = true; busy(true);
    var t = topic(), fd = new FormData();
    fd.append('tema', TEMA_CS[t]); fd.append('jmeno', val('jmeno')); fd.append('email', val('email')); fd.append('telefon', val('telefon'));
    fd.append('objednavka', t === 'design' || t === 'b2b' ? '' : val('objednavka')); fd.append('zprava', val('zprava'));
    fd.append('kontext_stranka', (document.title || '').slice(0, 200)); fd.append('kontext_url', location.href.slice(0, 500)); fd.append('kontext_shop', location.hostname);
    fd.append('hp', val('hp'));
    if (t === 'design') files.filter(function (f) { return f.ok; }).forEach(function (f) { fd.append('foto', f.file, f.file.name); });
    var wait = Math.max(0, MIN_MS - (Date.now() - openedAt));
    setTimeout(function () {
      fd.append('t', String(Date.now() - openedAt));
      var x = new XMLHttpRequest(); x.open('POST', api); x.timeout = 90000;
      if (x.upload && t === 'design' && files.length) x.upload.onprogress = function (e) { if (e.lengthComputable && sending) busy(true, Math.min(99, Math.round(e.loaded / e.total * 100))); };
      x.onerror = x.ontimeout = function () { showFail(T('e_net', '<a href="mailto:' + mail + '">' + mail + '</a>')); };
      x.onload = function () {
        var r = {}; try { r = JSON.parse(x.responseText); } catch (e) { }
        if (x.status === 200 && r.ok) {
          busy(false); $('[data-kt-done-mail]').textContent = val('email');
          form.hidden = true; done.hidden = false; done.classList.remove('is-in'); void done.offsetWidth; done.classList.add('is-in');
          done.focus({ preventScroll: true }); try { card.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { }
          return;
        }
        showFail(x.status === 429 ? T('e_429') : T('e_status', '<a href="mailto:' + mail + '">' + mail + '</a>'));
      };
      x.send(fd);
    }, wait);
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  $('[data-kt-retry]').addEventListener('click', submit);
  $('[data-kt-again]').addEventListener('click', function () {
    form.reset(); files = []; draw(); done.hidden = true; form.hidden = false; openedAt = Date.now() - MIN_MS; applyTopic();
    $$('[aria-invalid]', form).forEach(function (n) { n.removeAttribute('aria-invalid'); }); $$('[data-err]').forEach(function (n) { n.textContent = ''; });
    form.elements.jmeno.focus();
  });
})();
